import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { FacultyPage } from '@features/groups/components/pages/FacultyPage'
import { facultyQueryOptions, groupsQueryOptions } from '@features/groups/queries'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/faculty/$facultyId/')({
    component: RouteComponent,
    loader: async ({ params, context }) => {
        context.queryClient.ensureQueryData(facultyQueryOptions({ mode: 'id', id: params.facultyId }))
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'id', identifier: params.facultyId, type: 'department' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load faculty'>
            <Suspense fallback={<LoadingIndicator resource='faculty' />}>
                <FacultyPage mode='id' navMode='id' id={Route.useParams().facultyId} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
